export const firstToUpper = (string: string) => {
    const s = string.toLowerCase()

    return s.charAt(0).toUpperCase() + s.slice(1)
}
